import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import colors from '../../constants/colors';

const Badge = (props) => {
  return (
    <View style={[styles(props).container, props.style && props.style]}>
      <Text style={[styles(props).text, props.fontSize && { fontSize: props.fontSize }]}>{props.text}</Text>
    </View>
  )
}

const styles = (props) => StyleSheet.create({
  container: {
    backgroundColor: props.color,
    borderRadius: 50,
    paddingHorizontal: 6
  },
  text: {
    color: colors.white,
    fontSize: 12,
    margin: 'auto'
  }
})

export default Badge;
